import React from 'react';
import PropTypes from 'prop-types';

import { fromJS } from 'immutable';
import ItemField from '../../../Components/ItemField/ItemField';
import withToggleView from '../../../Components/ToggleView/ToggleView';

const BlockCoverages = ({ product, strings, /* family, */ insuranceKind, id }) => {
  const { coverages } = product;
  const {item_descriptors} = product


  /* const getFamily = code => {
    const selection = family.getIn(['selection']) ? family.getIn(['selection']).toJS() : undefined;
    let label = code;
    if (Array.isArray(selection)) {
      selection.some(item => {
        if (item[0] === code) {
          // eslint-disable-next-line prefer-destructuring
          label = item[1];
          return true;
        }
        return false;
      });
    }
    return label;
  }; */

  // const getInsuranceKind = code => {
  //   const selection = insuranceKind.getIn(['selection']) ? insuranceKind.getIn(['selection']).toJS() : [];
  //   let label = code;
  //   if (Array.isArray(selection)) {
  //     selection.some(item => {
  //       if (item[0] === code) {
  //         // eslint-disable-next-line prefer-destructuring
  //         label = item[1];
  //         return true;
  //       }
  //       return false;
  //     });
  //   }
  //   return label;
  // };

  const contentViewBlock = Array.isArray(item_descriptors)
    ? item_descriptors.map(itemDescriptor => (
      itemDescriptor.coverages.map(coverage => {
        return (
          <div className="coverage" key={`${coverage.code}-${coverage.id}`}>
            <div className="group name">
              <ItemField
                label={strings['product.block.coverages.field.rec_name.label'] || 'Nom'}
                value={coverage.name}
                name="rec_name"
                optional
              />
            </div>
            <div className="group">
              <ItemField
                label={strings['product.block.coverages.field.description.label'] || 'Description'}
                value={coverage.description}
                name="description"
                optional
              />
              {/* <ItemField
                label={strings['product.block.coverages.field.code.label'] || 'Code'}
                value={coverage.code}
                name="code"
                optional
              /> */}
              {/* <ItemField
                label={strings['product.block.coverages.field.family.label'] || 'Famille'}
                value={getFamily(coverage.family)}
                name="family"
                optional
              /> */}
              {/* <ItemField
                label={strings['product.block.coverages.field.insurance_kind.label'] || "Type d'assurance"}
                value={getInsuranceKind(coverage.insurance_kind)}
                name="insurance_kind"
                optional
              /> */}
            </div>
          </div>
        )
      })
    ))
    : undefined;

  return (
    <div className="content" key={id}>
      {contentViewBlock}
    </div>
  );
};

BlockCoverages.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strings: PropTypes.objectOf(PropTypes.string),
  // eslint-disable-next-line react/forbid-prop-types
  product: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  // family: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  insuranceKind: PropTypes.object,
};

BlockCoverages.defaultProps = {
  product: {},
  strings: fromJS({}),
  // family: fromJS({}),
  insuranceKind: fromJS({}),
};

const config = {
  title: 'product.block.coverages.title',
  defaultTitle: 'Informations',
  name: 'coverages',
  active: false,
};

export default withToggleView(BlockCoverages, config);
